import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { RecurringBuyRoutingModule } from '@app/authenticated/recurring-buy/recurring-buy-routing.module';
import { RecurringBuyComponent } from '@app/authenticated/recurring-buy/recurring-buy.component';
import { QRCodeComponent } from 'angularx-qrcode';

@NgModule({
  declarations: [RecurringBuyComponent],
  imports: [CommonModule, SharedModule, RecurringBuyRoutingModule, QRCodeComponent],
  exports: [],
})
export class RecurringBuyModule {}
